import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ReactSelectMaterialUi from 'react-select-material-ui';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
// import listMenuChildTypes from '../../constants/MenuChildType';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction, // roles,
    editConfirm,
    taxTypes,
    reducedTaxMenuPrefix,
    openEditProgress,
    progressOkAction,
    loading,
    resultMessage,
    isLanguage,
    setIsLanguage,
    previewImage,
    reducedTaxCheck,
    groupName,
    tagStr,
    prefectures
  }) => {
    let { menuName, menuEventName, description } = editConfirm;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = editConfirm.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        ({ menuName, menuEventName, description } = languageData.params);
      } else {
        menuName = 'Google Translate で自動的に翻訳されるもの';
        menuEventName = 'Google Translate で自動的に翻訳されるもの';
        description = 'Google Translate で自動的に翻訳されるもの';
      }
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー編集確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            hidden={editConfirm.manual === 1}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  イベント名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuEventName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  チケット発行種別
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.isETicket === 1 ? '電子' : '紙印刷'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  メニュー名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {(() => {
                    if (reducedTaxCheck) {
                      return reducedTaxMenuPrefix;
                    }
                    return '';
                  })()}
                  {menuName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  イベントメニューの作成方
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {editConfirm.manual === 1
                    ? 'イベントメニューのマニュアルで挿入'
                    : 'イベントメニューの自動挿入'}
                </TableCell>
              </TableRow>
              {editConfirm.manual === 0 && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      利用方法
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.menuLimitTotal === 1
                        ? '一円単位利用'
                        : '一枚単位利用'}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      価格
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {editConfirm.price}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      税区分
                      <br />
                      ・寄付
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {taxTypes.map(item => {
                        if (
                          editConfirm.taxType.toString() === item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      軽減税率対象
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {reducedTaxCheck}
                      {(() => {
                        if (reducedTaxCheck) {
                          return '対象';
                        }
                        return '対象外';
                      })()}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  プレミアム率
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${editConfirm.premiumPercent}%`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  都道府県
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {prefectures}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  グループ
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {groupName}
                </TableCell>
              </TableRow>
              {editConfirm.manual === 1 && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    回数券
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.menuCombo === 1
                      ? '回数券チケット'
                      : '回数券ではないチケット'}
                  </TableCell>
                </TableRow>
              )}
              {editConfirm.manual === 0 && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    適用対象
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.gochimeshiFlag === 1
                      ? '全ごちめしシステム'
                      : '本イベントだけ'}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>説明</TableCell>
                <TableCell className={classes.tableCellData}>
                  {description}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>タグ</TableCell>
                <TableCell className={classes.tableCellData}>
                  {tagStr}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>画像</TableCell>
                <TableCell className={classes.tableCellData}>
                  <ImagePreview previewImage={previewImage} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
